import { useEffect } from 'react';

let activeLocks = 0;
let restoreEntries = [];

const getLockTargets = () => {
  if (typeof document === 'undefined') return [];
  return [
    document.documentElement,
    document.body,
    document.querySelector('.content-wrapper'),
  ].filter(Boolean);
};

const acquireLock = () => {
  activeLocks += 1;
  if (activeLocks !== 1) return;

  restoreEntries = getLockTargets().map((element) => ({
    element,
    overflow: element.style.overflow,
    overscrollBehavior: element.style.overscrollBehavior,
  }));

  restoreEntries.forEach(({ element }) => {
    element.style.overflow = 'hidden';
    element.style.overscrollBehavior = 'none';
  });
};

const releaseLock = () => {
  activeLocks = Math.max(0, activeLocks - 1);
  if (activeLocks !== 0) return;

  restoreEntries.forEach(({
    element,
    overflow,
    overscrollBehavior,
  }) => {
    element.style.overflow = overflow;
    element.style.overscrollBehavior = overscrollBehavior;
  });
  restoreEntries = [];
};

const useAppScrollLock = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;

    acquireLock();
    return releaseLock;
  }, [enabled]);
};

export default useAppScrollLock;
